module.exports = __webpack_public_path__ + "img/4.f04d0c5e.jpg";